import React from 'react';
import Slider from 'react-slick';
import { Row, Col } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import resources from '../resources';
import languages from '../appdata/languages'; // 👈 thêm dòng này
import StoreManager from '../appdata';
class AIStrategy extends React.Component {
  state = {
    isMobile: window.innerWidth < 768,
    currentSlide: 0,
    isHoverPrev: false,
    isHoverNext: false,
  };
  sliderItemRefs = [];

  sliderRef = React.createRef();

  componentDidMount() {
    window.addEventListener('resize', this.updateDevice);
    setTimeout(this.updateMaxHeight, 200); // delay 1 chút để đảm bảo DOM render xong

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDevice);
  }
  updateMaxHeight = () => {
    const heights = this.sliderItemRefs.map(ref => ref?.offsetHeight || 0);
    const maxHeight = Math.max(...heights);
    this.setState({ maxSlideHeight: maxHeight });
  };

  updateDevice = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  handlePrev = () => {
    this.sliderRef.current.slickPrev();
  };

  handleNext = () => {
    this.sliderRef.current.slickNext();
  };

  render() {
    const { isMobile, currentSlide } = this.state;

    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].AIStrategyContent;
    var backgroundImage = isMobile
      ? resources.images.aibackgroundmobile
      : resources.images.aibackground;
  
    // if (currentSlide == 1) {
    //   backgroundImage = isMobile
    //     ? resources.images.aibackgroundmobile2
    //     : resources.images.aibackground2;
    // }
    // if (currentSlide == 2) {
    //   backgroundImage = isMobile
    //     ? resources.images.aibackgroundmobile3
    //     : resources.images.aibackground3;
    // }
    // if (currentSlide == 3) {
    //   backgroundImage = isMobile
    //     ? resources.images.aibackgroundmobile4
    //     : resources.images.aibackground4;
    // }



    const settings = {
      dots: false,
      infinite: true,
      autoplay: true,
      speed: 2500,
      autoplaySpeed: 6000,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: (_, next) => this.setState({ currentSlide: next }),
    };

    return (
      <section style={{ position: 'relative', overflow: 'hidden' }}>
        {/* Background Layer with Transition */}
        <div
          key={currentSlide} // force re-render to trigger transition
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 1,
            transition: 'opacity 0.8s ease',
            zIndex: 0,
          }}
        />

        {/* Content Layer */}
        <div style={{ position: 'relative', zIndex: 1, padding: isMobile ? '60px 16px' : '100px 40px', color: 'white' }}>
          <div style={{ maxWidth: 1040, margin: '0 auto' }}>
            <Row gutter={[40, 40]} align="top">
              <Col xs={24} md={10}>
                <div
                  style={{
                    border: '1px solid white',
                    borderRadius: 999,
                    display: 'inline-block',
                    padding: '6px 20px',
                    fontSize: 16,
                    fontWeight: 600,
                    marginBottom: 16,
                    color: 'white',

                  }}
                >
                  {lang.badge}
                </div>

                <h2
                  style={{
                    fontSize: isMobile ? 32 : 56,
                    fontWeight: 700,
                    lineHeight: 1.2,
                    marginBottom: 32,
                    whiteSpace: 'pre-line',
                    color: 'white',
                  }}
                >
                  {lang.title}
                </h2>

                {!isMobile && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
                                        <div style={{ display: 'flex', gap: 12 }}>
  <div
    onClick={this.handlePrev}
    onMouseEnter={() => this.setState({ isHoverPrev: true })}
    onMouseLeave={() => this.setState({ isHoverPrev: false })}
    style={{
      ...arrowStyle,
      backgroundColor: this.state.isHoverPrev ? '#ffffff' : 'transparent',
    }}
  >
    <ArrowLeftOutlined style={{ color: this.state.isHoverPrev ? '#000000' : '#ffffff' }} />
  </div>

  <div
    onClick={this.handleNext}
    onMouseEnter={() => this.setState({ isHoverNext: true })}
    onMouseLeave={() => this.setState({ isHoverNext: false })}
    style={{
      ...arrowStyle,
      backgroundColor: this.state.isHoverNext ? '#ffffff' : 'transparent',
    }}
  >
    <ArrowRightOutlined style={{ color: this.state.isHoverNext ? '#000000' : '#ffffff' }} />
  </div>
</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginLeft: 16 }}>
                      {lang.slides.map((_, idx) => (
                        <div key={idx} style={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: idx === currentSlide ? '#fff' : '#888',
                          transition: 'all 0.3s ease',
                          transform: idx === currentSlide ? 'scale(1.3)' : 'scale(1)',
                          color: 'white',
                        }} />
                      ))}
                    </div>
                  </div>
                )}
              </Col>

              <Col xs={24} md={14}>
                {isMobile && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, padding: 12 }}>
                    <div style={{ display: 'flex', gap: 12 }}>
                      <div onClick={this.handlePrev} style={arrowStyle}><ArrowLeftOutlined style={{ color: 'white' }} /></div>
                      <div onClick={this.handleNext} style={arrowStyle}><ArrowRightOutlined style={{ color: 'white' }} /></div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                      {lang.slides.map((_, idx) => (
                        <div key={idx} style={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: idx === currentSlide ? '#fff' : '#888',
                          transition: 'all 0.3s ease',
                          transform: idx === currentSlide ? 'scale(1.3)' : 'scale(1)',
                          color: 'white',
                        }} />
                      ))}
                    </div>
                  </div>
                )}

                <Slider ref={this.sliderRef} {...settings}>
                  {lang.slides.map((item, index) => (
                    <div key={index} style={{ padding: 20 }}>
                      <div
                        ref={ref => (this.sliderItemRefs[index] = ref)}
                        style={{
                          minHeight: this.state.maxSlideHeight || 'auto',
                          padding: 10,
                          display: 'flex',
                          alignItems: 'stretch',
                        }}
                      >
                        <div style={{
                          backgroundColor: 'rgba(0, 0, 0, 0.4)',
                          borderRadius: 20,
                          padding: isMobile ? 20 : 32,
                          backdropFilter: 'blur(10px)',
                          color: 'white',
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                        }}>
                          <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 12, color: 'white' }}>
                            {item.title}
                          </div>
                          <p style={{ fontSize: 16, lineHeight: '28px', color: 'white' }}>{item.content}</p>
                        </div>
                      </div>
                    </div>
                  ))}


                </Slider>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    );

  }
}

const arrowStyle = {
  width: 40,
  height: 40,
  borderRadius: '50%',
  border: '1px solid white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

export default AIStrategy;
